import { useRouter } from 'next/router';
import getConfig from 'next/config';

import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import errorTrack from '../../../util/Genesys';
import { clearAllCookies } from '../../hooks/useCookie';
import { clearLocalStorage } from '../../hooks/useLocalStorage';

const { publicRuntimeConfig } = getConfig();

const UANErrorModal = ({ errorUANModal }) => {
  const router = useRouter();
  const handleChatNow = modalId => {
    errorTrack(modalId);
  };
  const handleOk = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_CONTACT_NUMBER}`);
  };
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'CS-cannot_proceed',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
    clearAllCookies();
    clearLocalStorage();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={errorUANModal.value}
      handleClose={errorUANModal.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      iconAlt={cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.alternativeText}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: 'Chat now',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Chat now',
          type: 'solid',
          action: () => handleChatNow(cmsCollectionData?.attributes?.modalID),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
        {
          // text: 'Call 1800 303 641',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Call 1800 303 641',
          type: 'contained',
          action: () => handleOk(errorUANModal),
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default UANErrorModal;
